<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <g fill="none" fill-rule="evenodd">
      <g fill="#13A2E8">
        <g>
          <g>
            <path
              d="M21.659.342c.455.455.455 1.192 0 1.647L12.647 11l9.012 9.012c.455.455.455 1.192 0 1.647-.228.227-.526.341-.824.341-.298 0-.596-.114-.824-.34L11 12.646l-9.011 9.012c-.228.227-.526.341-.824.341-.298 0-.596-.114-.824-.34-.455-.456-.455-1.193 0-1.648L9.352 11 .342 1.989C-.115 1.534-.115.797.341.342c.454-.456 1.192-.456 1.647 0L11 9.353 20.012.342c.454-.456 1.192-.456 1.647 0z"
              transform="translate(-936 -229) translate(458 205) translate(478 24)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>